export default __webpack_public_path__ + "static/minority-a4f5f6a87598ed07008de851f2095f98.png";